export default __webpack_public_path__ + "static/media/Program1_documents_2.6972d4e1.jpg";